<template>
    <v-menu :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-btn class="emoji-invoker" v-on="on" icon>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </v-btn>
      </template>
      <div>
        <div class="emoji-picker">
            <div v-for="(emojiGroup, category) in emojis" :key="category">
<!--              <h5>{{ category }}</h5>-->
              <div class="emojis">
                <span
                  v-for="(emoji, emojiName) in emojiGroup"
                  :key="emojiName"
                  @click="insert(emoji)"
                  :title="emojiName"
                  >{{ emoji }}</span
                >
              </div>
            </div>
        </div>
      </div>
    </v-menu>

</template>

<script>
import emojis from "./js/emojis";

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export default {
  props: {
    search: {
      type: String,
      required: false,
      default: "",
    },
    emits: ['emoji'],
    emojiTable: {
      type: Object,
      required: false,
      default() {
        return emojis;
      },
    },
  },
  data() {
    return {
    };
  },
  computed: {
    emojis() {
      if (this.search) {
        const obj = {};

        for (const category in this.emojiTable) {
          obj[category] = {};

          for (const emoji in this.emojiTable[category]) {
            if (new RegExp(`.*${escapeRegExp(this.search)}.*`).test(emoji)) {
              obj[category][emoji] = this.emojiTable[category][emoji];
            }
          }

          if (Object.keys(obj[category]).length === 0) {
            delete obj[category];
          }
        }

        return obj;
      }

      return this.emojiTable;
    },
  },
  methods: {
    insert(emoji) {
      this.$emit("emoji", emoji);
    },
  },
};
</script>

<style scoped>
/* Tailwind CSS-styled demo is available here: https://codepen.io/DCzajkowski/pen/Brxvzj */

.wrapper {
  position: relative;
  display: inline-block;
}

.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.emoji-invoker {
}

.emoji-invoker:hover {
  transform: scale(1.1);
}

.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 15rem;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}

.emoji-picker__search {
  display: flex;
}

.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}

.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}

.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}

.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}

.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
</style>
